import { render, staticRenderFns } from "./StandardLayout.vue?vue&type=template&id=5f01cb6c&scoped=true&"
import script from "./StandardLayout.vue?vue&type=script&lang=ts&"
export * from "./StandardLayout.vue?vue&type=script&lang=ts&"
import style0 from "./StandardLayout.vue?vue&type=style&index=0&id=5f01cb6c&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f01cb6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VContainer,VContent,VSpacer,VToolbar})
